import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface Profile {
  user_id: string;
  company_id: string;
  full_name?: string;
  email?: string;
}

export function useProfile() {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const { data: userData } = await supabase.auth.getUser();
      
      if (!userData.user) {
        throw new Error("Usuário não autenticado");
      }

      const { data, error } = await supabase
        .from("profiles")
        .select("user_id, company_id, full_name, email")
        .eq("user_id", userData.user.id)
        .single();

      if (error) throw error;
      return data as Profile;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}
